<template>
  <div class="content importList">
    <div class="search-area">
      <div class="w100f t-left mb15"><b>选择需要导入的数据</b></div>
      <div class="import-a-sty">
        <!-- <a @click="toLink('/importOfSalesFlow')">销售流向导入</a><label> | </label> -->
        <a @click="toLink('/importTerminal')">药店导入</a> <label> | </label>
        <a @click="toLink('/importCommercialCompany')">商业公司导入</a> <label> | </label>
        <a @click="toLink('/importHospital')">医院导入</a> <label> | </label>
        <a class="fontC-4fa1a4" @click="toLink('/importDoctor')">客户联系人导入</a>
        <!-- <a @click="toLink('/importMeeting')">学术活动计划导入</a> -->
      </div>
    </div>
    <div class="search-area mt15">
      <div class="import-sty">
        <el-steps :active="active" align-center>
          <el-step title="上传文件"></el-step>
          <el-step title="确认数据"></el-step>
          <el-step title="导入完成"></el-step>
        </el-steps>
        <div v-if="active == 0">
          <div class="import-box ml71 mt50">
            <div class="import-box-list">
              <div class="import-box-label"><span style="color: red">*</span>导入企业：</div>
              <el-select v-model="tenantGuid" placeholder="请选择" filterable style="width: 300px">
                <el-option
                  v-for="item in tenantList"
                  :key="item.sendTenantGuid"
                  :label="item.sendTenantName"
                  :value="item.sendTenantGuid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="import-box-list">
              <div class="import-box-label"><span style="color: red">*</span>客户类型：</div>
              <el-select v-model="customerValue" placeholder="请选择" style="width: 300px">
                <el-option v-for="item in customerOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="import-box-list">
              <div class="import-box-label">下载模板：</div>
              <el-button plain size="medium" @click="uploadExcel">下载文件模板</el-button>
            </div>
            <div class="import-box-list">
              <div class="import-box-label">导入文件：</div>
              <div class="upload-btn-box">
                <el-upload
                  v-if="tenantGuid && customerValue"
                  class="upload-demo fl"
                  action="#"
                  :before-upload="beforeUpload"
                  multiple
                  :limit="1"
                  accept=".xlsx,.xsl,.xls,.xlsm"
                  :auto-upload="false"
                  :on-change="changeFile"
                  :on-exceed="handleExceed"
                >
                  <el-button size="medium" type="info" v-loading.fullscreen.lock="fullscreenLoading"
                    >点击上传文件</el-button
                  >
                </el-upload>
                <el-button v-else size="medium" type="info" style="width: 126px" @click="uploadMessage()"
                  >点击上传文件</el-button
                >
                <div slot="tip" class="el-upload__tip">
                  当前仅支持 excel 格式文件（大小在5M以内），请使用 Office 2010 及以上版本，否则可能出现乱码<br />
                  必须严格按照模板内容填入数据，否则可能会出现导入异常
                </div>
              </div>
            </div>
          </div>
          <div class="mt15 t-right">
            <el-button size="medium" type="info" @click="next()">下一步</el-button>
          </div>
        </div>
      </div>
      <div v-if="active == 1" class="mt15">
        <div class="summary-sty">
          预计导入<b class="fontC-4fa1a4"> {{ totalRows }} </b>条数据，其中<b class="fontC-4fa1a4"> {{ errorRows }} </b
          >条可能有误，请调整后再导入
          <a class="txt-color-blue ml10" @click="getDataAll()">全部数据 | </a>
          <a class="txt-color-blue" @click="getDataErrorFlagY()">只看错误数据 | </a>
          <a class="txt-color-blue" @click="getDataErrorFlagN()">只看准确数据</a>
          <span style="float: right; padding-right: 10px; color: #4fa1a4; cursor: pointer" @click="pitchDelet"
            >批量删除</span
          >
        </div>
        <!-- 医生 -->
        <el-table
          :data="tableData"
          v-if="customerValue == 1"
          border
          style="width: 100%"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="colA" label="医生姓名" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colA" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colB" label="手机号" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colB" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colC" label="性别" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colC" placeholder="请选择">
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="colD" label="所在医院" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colD" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colE" label="所在科室" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colE" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colF" label="医师职称" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colF" placeholder="请选择" filterable>
                <el-option v-for="item in doctorTypeOption" :key="item.label" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="colG" label="所在省份" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colG" placeholder="请选择" @change="province(scope.row.colG)" filterable>
                <el-option v-for="item in provinceList" :key="item.label" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="colH" label="所在市" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colH" placeholder="请选择" @change="city(scope.row.colH)">
                <el-option v-for="item in cityList" :key="item.label" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="colI" label="所在区/县" header-align="center" align="center" width="250">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colI" placeholder="请选择">
                <el-option v-for="item in districtList" :key="item.label" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="colJ" label="所属人姓名" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colJ" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colK" label="所属人手机号" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colK" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colK" label="建档时间" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colL" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorInfo"
            label="错误信息"
            header-align="center"
            align="center"
            fixed="right"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.errorInfo | errorInfo }}
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <a class="txt-color" @click="save(scope.row)">保存 | </a>
              <a class="txt-color-red" @click="deletes(scope.row.guid)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <!-- 商业客户 -->
        <el-table
          :data="tableData"
          v-if="customerValue == 2"
          border
          style="width: 100%"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="colA" label="所属公司" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colA" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colB" label="姓名" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colB" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colC" label="联系方式" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colC" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colD" label="性别" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colD" placeholder="请选择">
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="colE" label="岗位" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colE" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colF" label="所属人手机号" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colF" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colG" label="所属人手机号" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colG" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colH" label="建档时间" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colH" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorInfo"
            label="错误信息"
            header-align="center"
            align="center"
            fixed="right"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.errorInfo | errorInfo }}
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <a class="txt-color" @click="save(scope.row)">保存 | </a>
              <a class="txt-color-red" @click="deletes(scope.row.guid)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <!-- 居间人 -->
        <el-table
          :data="tableData"
          v-if="customerValue == 3"
          border
          style="width: 100%"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="colA" label="姓名" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colA" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colB" label="联系方式" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colB" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colC" label="性别" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colC" placeholder="请选择">
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="colD" label="客户类型" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colD" placeholder="请选择">
                <el-option label="医院" value="医院"></el-option>
                <el-option label="商业公司" value="商业公司"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="colE" label="负责客户" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colE" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colF" label="代理产品" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colF" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colG" label="业务员能力" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colG" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colH" label="业绩指标(元)" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colH" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colI" label="擅长品类" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colI" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colJ" label="专长领域一级" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colJ" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colK" label="专长领域二级" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colK" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colL" label="覆盖城市" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colL" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colM" label="所属人手机号" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colM" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colN" label="所属人手机号" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colN" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colO" label="建档时间" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-select v-model="scope.row.colO" placeholder="请选择" filterable>
                <el-option v-for="item in doctorTypeOption" :key="item.label" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorInfo"
            label="错误信息"
            header-align="center"
            align="center"
            fixed="right"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.errorInfo | errorInfo }}
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <a class="txt-color" @click="save(scope.row)">保存 | </a>
              <a class="txt-color-red" @click="deletes(scope.row.guid)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pt pb back-color-fff"
          style="padding: 16px"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
        <div class="mt15 t-right">
          <el-button size="medium" plain @click="active = 0">取消</el-button>
          <el-button size="medium" type="info" @click="nextImport()" v-loading.fullscreen.lock="fullscreenLoading"
            >导入</el-button
          >
        </div>
      </div>

      <div class="font-S16 mt50 h150" v-if="active >= 2">
        <img width="64" height="64" src="../../assets/images/right.png" /><br /><br />
        导入成功，本次共导入<b class="fontC-4fa1a4">{{ importSum }}</b
        >条数据
      </div>
    </div>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      url1: `/${serverConfig.msPersonnelService}/import-data/doctor?tenantGuid=`,
      url2:
        `/${serverConfig.msPersonnelService}/import-data/addressList?serviceTenantGuid=${localStorage.guid}&clientType=1&tenantGuid=`,
      url3:
        `/${serverConfig.msPersonnelService}/import-data/addressList?serviceTenantGuid=${localStorage.guid}&clientType=2&tenantGuid=`,
      active: 0,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        importType: '0002',
        errorFlag: '',
        tenantGuid:''
      },
      customerOption: [
        { label: '医生', value: '1' },
        { label: '商业客户', value: '2' },
        { label: '居间人', value: '3' },
      ],
      importSum: 0,
      loading: true,
      tableData: [],
      provinceList: areaJson,
      cityList: [],
      districtList: [],
      guids: [],
      errorRows: 0,
      totalRows: 0,
      fullscreenLoading: false,
      doctorTypeOption: [],
      checkedList: [],
      customerValue: '',
      tenantGuid: '',
      tenantList: [],
    };
  },
  created() {
    if (this.$route.query.type == 'business') {
      this.customerValue = '2';
    } else if (this.$route.query.type == 'intermediary') {
      this.customerValue = '3';
    }
    this.getDoctorType();
    this.getTenantOperationRelList();
  },
  watch: {},
  mounted() {},
  methods: {
    //获取医师职称下拉字典
    getDoctorType() {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${this.$store.state.guid}&code=YSZC_HYS`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            let arr = [];
            data.forEach((item) => {
              let obj = {
                label: item.name,
                value: item.parameterValue,
              };
              arr.push(obj);
            });
            that.doctorTypeOption = arr;
          }
        });
    },
    toLink(link) {
      this.$router.push({ path: link });
    },
    province(pr) {
      let self = this;
      self.cityList = [];
      self.provinceList.forEach(function (i) {
        if (i.label == pr) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              self.cityList.push(j);
            });
          }
        }
      });
    },
    city(ci) {
      let self = this;
      console.log(self.cityList);
      self.districtList = [];
      self.cityList.forEach(function (i) {
        if (i.label == ci) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              self.districtList.push(j);
            });
          }
        }
      });
    },
    //获取公司下拉
    getTenantOperationRelList(flg) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.tenantList = res.data.data || [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    uploadExcel() {
      if (!this.customerValue) {
        this.$message.error('请选择客户类型！');
        return;
      }
      if (this.customerValue == 1) {
        window.open('/医生数据导入.xlsx');
      } else if (this.customerValue == 2) {
        window.open('/商业客户导入.xlsx');
      } else if (this.customerValue == 3) {
        window.open('/居间人导入.xlsx');
      }
    },
    uploadMessage() {
      if (!this.tenantGuid) {
        this.$message.error('请选择导入企业！');
        return;
      }
      if (!this.customerValue) {
        this.$message.error('请选择客户类型！');
        return;
      }
    },
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!')
        return false
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    changeFile(file, fileList) {
      let self = this;
      let isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        self.$message.error('上传文件大小不能超过 5MB');
        file = null;
        fileList = [];
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
      } else {
        self.fullscreenLoading = true;
        let formData = new FormData();
        formData.append('file', file.raw); //传文件
        let url = '';
        if (this.customerValue == 1) {
          url = self.url1 + this.tenantGuid + '&serviceTenantGuid=' + localStorage.guid + '&progressGuid=' + self.generateUUID();
        } else if (this.customerValue == 2) {
          url = self.url2 + this.tenantGuid + '&progressGuid=' + self.generateUUID();
        } else if (this.customerValue == 3) {
          url = self.url3 + this.tenantGuid + '&progressGuid=' + self.generateUUID();
        }
        self.api.postFile(url, formData).then(function (res) {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message({
              type: 'success',
              message: '上传成功',
            });
          } else {
            self.$message({
              type: 'warning',
              message: '数据格式不正确！',
            });
            return false;
          }
        });
      }
    },
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
    next() {
      let self = this;
      self.active = 1;
      self.getData(true);
    },
    getDataAll() {
      let self = this;
      self.page.errorFlag = '';
      self.getData(true);
    },
    getDataErrorFlagY() {
      let self = this;
      self.page.errorFlag = 'Y';
      self.getData(true);
    },
    getDataErrorFlagN() {
      let self = this;
      self.page.errorFlag = 'N';
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableData = [];
      if (this.customerValue == 1) {
        self.page.importType = '0002';
      } else if (this.customerValue == 2) {
        self.page.importType = '0009';
      } else if (this.customerValue == 3) {
        self.page.importType = '0010';
      }
      self.page.tenantGuid = self.tenantGuid;
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/import-data/get-import-intermediate-data`, self.page)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.details.records;
            self.errorRows = res.data.data.errorRows;
            self.totalRows = res.data.data.totalRows;
            self.page.totalPage = res.data.data.details.totalPages;
            self.page.totalRows = res.data.data.details.totalRows;
            self.loading = false;
          } else {
            self.$message.error(res.data.msg);
            self.loading = false;
          }
        });
    },
    save(row) {
      let self = this;
      // row.colA = self.$moment(row.colA).format('YYYY-MM-DD HH:mm:ss');
      if (row.colC == '市辖区' || row.colC == 'colC') {
        row.colC = row.colB;
      }
      row.errorFlag = 'N';
      row.errorInfo = '';
      self.loading = true;
      self.api.put(`/${serverConfig.msPersonnelService}/import-data/update-intermediate-data`, row).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('保存成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
          self.loading = false;
        }
      });
    },
    deletes(guid) {
      let self = this;
      self.guids = [];
      self.guids.push(guid);
      self.loading = true;
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/import-data/delete-intermediate-data`, self.guids)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
            self.loading = false;
          }
        });
    },
    // 多选删除
    handleSelectionChange(val) {
      console.log('多选删除', val);
      let arr = [];
      val.forEach((item) => {
        arr.push(item.guid);
      });
      this.checkedList = arr;
    },
    pitchDelet() {
      if (this.checkedList.length) {
        let self = this;
        self.loading = true;
        self.api
          .postJson(`/${serverConfig.msPersonnelService}/import-data/delete-intermediate-data`, self.checkedList)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
              self.loading = false;
            }
          });
      } else {
        this.$message.error('请勾选需要删除的数据！');
      }
    },
    nextImport() {
      let self = this;
      self.fullscreenLoading = true;
      let url = '';
      if (this.customerValue == 1) {
        url = '/import-data/finish-doctor';
      } else if (this.customerValue == 2) {
        url = '/import-data/finish-addressList-customer';
      } else if (this.customerValue == 3) {
        url = '/import-data/finish-addressList-user';
      }
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}${url}?tenantGuid=` +
            this.tenantGuid +
            '&progressGuid=' +
            this.generateUUID(),
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.importSum = res.data.data;
            self.$message.success('导入成功');
            self.active = 3;
            self.fullscreenLoading = false;
          } else {
            self.active = 1;
            self.getData(true);
            self.$message.error(res.data.msg);
            self.fullscreenLoading = false;
          }
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      self.getData(false);
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      self.getData(false);
    },
  },
};
</script>
<style  scoped>
.importList /deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4 !important;
  border-color: inherit;
}
.importList /deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
.importList /deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.importList /deep/ .el-step__title.is-finish {
  color: #4fa1a4;
  font-weight: bold;
}
.import-box-list {
  display: flex;
  margin-bottom: 15px;
}
.import-box-label {
  width: 110px;
  line-height: 32px;
  text-align: right;
  flex-shrink: 0;
}
.upload-btn-box {
  display: flex;
  flex-direction: column;
}
</style>